import React, { useState, useEffect, useRef } from "react";
// import IQAMAH from "../pages/main/pic/IQAMAH.mp3";
import { getNotes, fetchItems } from "../api";
// import { fetchItems } from "../api";
import MICLogo from "../pages/main/pic/MICLogo.png";

import PrayerBoard from "../components/PrayerBoard";
import { getToday } from "../api";
import {
  todayMMDDYY,
  tomorrowMMDDYY,
  nowPretty,
  format12h,
  todayPretty,
  tomorrowPretty,
  scheduleMidnightReload,
  compareTime,
} from "../utils/date";
//email:micnytv@gmail.com
// Password: Micnytv@gmail.com@123

// samsung tv login: micnytv@gmail.com
// samsung tv password: MED$%#GehGHdf34
const azanAudio = new Audio("/azan.mp3"); // Put azan.mp3 in public folder

function gmod(n, m) {
  return ((n % m) + m) % m;
}

/* @param {Date}   date   - optional, default is today
 ** @param {number} adjust - optiona, days to adjust date by
 */
function kuwaiticalendar(date, adjust) {
  var today = date ? new Date(+date) : new Date();
  if (adjust) {
    today.setDate(today.getDate() + +adjust);
  }

  var day = today.getDate();
  var month = today.getMonth();
  var year = today.getFullYear();
  var m = month + 1;
  var y = year;

  if (m < 3) {
    y -= 1;
    m += 12;
  }

  var a = Math.floor(y / 100);
  var b = 2 - a + Math.floor(a / 4);

  if (y < 1583) b = 0;
  if (y == 1582) {
    if (m > 10) b = -10;
    if (m == 10) {
      b = 0;
      if (day > 4) b = -10;
    }
  }

  var jd =
    Math.floor(365.25 * (y + 4716)) +
    Math.floor(30.6001 * (m + 1)) +
    day +
    b -
    1524;

  b = 0;
  if (jd > 2299160) {
    a = Math.floor((jd - 1867216.25) / 36524.25);
    b = 1 + a - Math.floor(a / 4);
  }

  var bb = jd + b + 1524;
  var cc = Math.floor((bb - 122.1) / 365.25);
  var dd = Math.floor(365.25 * cc);
  var ee = Math.floor((bb - dd) / 30.6001);
  day = bb - dd - Math.floor(30.6001 * ee);
  month = ee - 1;

  if (ee > 13) {
    cc += 1;
    month = ee - 13;
  }
  year = cc - 4716;
  var wd = gmod(jd + 1, 7) + 1;

  var iyear = 10631 / 30;
  var epochastro = 1948084;
  var epochcivil = 1948085;

  var shift1 = 8.01 / 60;

  var z = jd - epochastro;
  var cyc = Math.floor(z / 10631);
  z = z - 10631 * cyc;
  var j = Math.floor((z - shift1) / iyear);
  var iy = 30 * cyc + j;
  z = z - Math.floor(j * iyear + shift1);
  var im = Math.floor((z + 28.5001) / 29.5);

  if (im == 13) im = 12;
  var id = z - Math.floor(29.5001 * im - 29);

  return [
    day, //calculated day (CE)
    month - 1, //calculated month (CE)
    year, //calculated year (CE)
    jd - 1, //julian day number
    wd - 1, //weekday number
    id, //islamic date
    im - 1, //islamic month
    iy, //islamic year
  ];
}

function writeIslamicDate(date, adjustment) {
  var wdNames = [
    "Ahad",
    "Ithnin",
    "Thulatha",
    "Arbaa",
    "Khams",
    "Jumuah",
    "Sabt",
  ];
  var iMonthNames = [
    "Muharram",
    "Safar",
    "Rabi'ul Awwal",
    "Rabi'ul Akhir",
    "Jumadal Ula",
    "Jumadal Akhira",
    "Rajab",
    "Sha'ban",
    "Ramadan",
    "Shawwal",
    "Dhul Qa'ada",
    "Dhul Hijja",
  ];
  var iDate = kuwaiticalendar(date, adjustment);
  var outputIslamicDate =
    wdNames[iDate[4]] +
    ", " +
    iDate[5] +
    " " +
    iMonthNames[iDate[6]] +
    " " +
    iDate[7] +
    " AH";
  return outputIslamicDate;
}

// Uporer pura ta arabic date er jonno

const formatTime = (date) => {
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  const minutesStr = minutes < 10 ? "0" + minutes : minutes;
  const secondsStr = seconds < 10 ? "0" + seconds : seconds;
  return hours + ":" + minutesStr + ":" + secondsStr + " " + ampm;
};

export default function Rotate90() {
  const wrapperStyle = {
    width: "99vw",
    height: "97vh",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#eee",
  };

  const rotatedStyle = {
    width: "100vh", // swap width/height because of rotation
    height: "100vw",
    transform: "rotate(270deg)",
    transformOrigin: "center center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#fff",
    // border: "1px solid #000",
  };

  const [data, setData] = useState(null);
  const [processed, setProcessed] = useState(null);
  const [tData, setTData] = useState(null);
  const [now, setNow] = useState(nowPretty());
  const [today, setToday] = useState(todayPretty());
  const [tomorroww, setTomorroww] = useState(tomorrowPretty());
  const [notes, setNotes] = useState([]);
  const [breakingNews, setBreakingNews] = useState(null);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  //step1: below is for pulling today's data from backend api
  useEffect(() => {
    getToday(todayMMDDYY())
      .then(setData)
      // .runAfterData(data)
      .catch(() => {});
    const timer = setInterval(() => setNow(nowPretty()), 1000);
    scheduleMidnightReload();
    return () => clearInterval(timer);
  }, []);
  //above is for pulling  today's data from backend api

  // Step 2: Run your function only after data is ready
  useEffect(() => {
    if (data) {
      const output = runAfterData(data); // your custom function
      setProcessed(output); // store processed result
    }
  }, [data]); // ekhan e data change holei run hobe abong data ready thakle run hobe abong data er upor depend kore abong data pura load hole tar por next line ta run hobe

  // Example function that depends on data
  function runAfterData(data) {
    // do something with data
    // console.log(data);
  }

  // below is for pulling tomorrow's data from backend api
  useEffect(() => {
    getToday(tomorrowMMDDYY())
      .then(setTData)
      .catch(() => {});
    const timer = setInterval(() => setNow(nowPretty()), 1000);
    scheduleMidnightReload();
    return () => clearInterval(timer);
  }, []);
  // above is for pulling tomorrow's data from backend api

  //bellow is pulling all notes from backend
  useEffect(() => {
    loadNotes();
  }, []);

  async function loadNotes() {
    const data = await getNotes();
    setNotes(data);
  }
  // console.log(notes);
  //above is pulling notes from backend

  //bellow is pulling all breaking news from backend
  useEffect(() => {
    fetchItems()
      .then(setBreakingNews)
      .then(() => setIsLoading(false))
      .catch((e) => {
        setError(e.message);
        setIsLoading(false);
      });
  }, []);

  // console.log(breakingNews && breakingNews);

  //above is pulling notes from backend

  // below line for countdown for 5 prayers or u can say how much time remaining for next prayer🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽
  // below line for countdown for 5 prayers or u can say how much time remaining for next prayer🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽

  const [nextPrayer1, setNextPrayer1] = useState(null);
  const [countdown1, setCountdown1] = useState("");

  function timeToSeconds(str) {
    const chars = Array.from(str);
    const colonIndex = chars.indexOf(":");
    const h = Number(chars.slice(0, colonIndex).join(""));
    const m = Number(chars.slice(colonIndex + 1).join(""));
    return h * 3600 + m * 60;
  }

  const order = [
    "fajrIqamah",
    "dhuhrIqamah",
    "asrIqamah",
    "maghribIqamah",
    "ishaIqamah",
  ];

  // Step 1: find the next prayer time
  function getNextPrayer() {
    const now = new Date();
    const nowSec =
      now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();

    for (let i = 0; i < order.length; i++) {
      const key = order[i];
      const targetSec = data && timeToSeconds(data[key]);
      if (targetSec > nowSec) {
        return key;
      }
    }
    // if past isha, loop back to fajr
    return "fajrIqamah";
  }

  // Step 2: update countdown every second
  useEffect(() => {
    function tick() {
      const key = data && getNextPrayer();
      setNextPrayer1(key);

      const now = new Date();
      const nowSec =
        now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
      const targetSec = data && timeToSeconds(data[key]);

      // if target is tomorrow (after isha), add 24h
      const diffSec =
        targetSec > nowSec
          ? targetSec - nowSec
          : 24 * 3600 - nowSec + targetSec;

      const h = Math.floor(diffSec / 3600);
      const m = Math.floor((diffSec % 3600) / 60);
      const s = diffSec % 60;

      // format with leading zeros
      const hh = String(h).padStart(2, "0");
      const mm = String(m).padStart(2, "0");
      const ss = String(s).padStart(2, "0");

      setCountdown1(`${hh}:${mm}:${ss}`);
    }

    tick(); // run immediately
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [data]);

  function removeIqamah(key) {
    return key?.endsWith("Iqamah")
      ? key?.slice(0, -"Iqamah".length) // remove last 6 chars
      : key;
  }

  // above line for countdown for 5 prayers or u can say how much time remaining for next prayer 🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝
  // above line for countdown for 5 prayers or u can say how much time remaining for next prayer 🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝

  const [isVisible, setIsVisible] = useState(true);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [hijriDate, setHijriDate] = useState("");
  const audioRef = useRef(null);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);
  //above is Now er next line ta holo per second update er jonno
  //above is Now er next line ta holo per second update er jonno

  //below is for arabic date🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽    🔻
  useEffect(() => {
    const today = new Date();
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      calendar: "islamic",
      numberingSystem: "latn",
    };
    const hijriFormatter = new Intl.DateTimeFormat("en-US", options);
    const formattedHijri = hijriFormatter.format(today);
    setHijriDate(formattedHijri);
  }, []);
  //above is for arabic date

  // below is for change the background to dark blue when preyer time thrashhold finishes 🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽    🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽
  // below is for change the background to dark blue when preyer time thrashhold finishes 🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽    🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽
  const [currentPrayer, setCurrentPrayer] = useState("");
  useEffect(() => {
    const checkPrayer = () => {
      const today = new Date();
      const todayDate = today.toLocaleDateString("en-US"); // "12/14/2025"
      // Your dataset uses "12/14/25" instead of "2025"
      const todayShort = todayDate.replace(/(\d+)$/, (y) => y.slice(-2)); // "12/14/25"
      // console.log(todayShort);
      // Find today's row
      // Normalize both to the same format
      function normalizeDate(str) {
        const [month, day, year] = str.split("/");
        return `${Number(month)}/${Number(day)}/${year}`;
      }

      const todayData =
        data && normalizeDate(data.date) === normalizeDate(todayShort);
      // console.log(data && data);
      // console.log(todayData);
      // console.log(data);

      function timeToSeconds(timeStr) {
        const [h, m] = timeStr && timeStr.split(":").map(Number);
        return h * 3600 + m * 60;
      }

      const fajr = data && timeToSeconds(data?.fajr);
      // console.log(fajr);

      const dhuhr = data && timeToSeconds(data?.dhuhr);
      // console.log(dhuhr);

      const asr = data && timeToSeconds(data?.asr);
      // console.log(asr);

      const maghrib = data && timeToSeconds(data?.maghrib);
      // console.log(maghrib);

      const isha = data && timeToSeconds(data?.isha);
      // console.log(isha);

      const nowSec =
        today.getHours() * 3600 + today.getMinutes() * 60 + today.getSeconds();

      // console.log(nowSec);

      if (nowSec >= fajr && nowSec < dhuhr) {
        setCurrentPrayer("Fajr");
      } else if (nowSec >= dhuhr && nowSec < asr) {
        setCurrentPrayer("Dhuhr");
      } else if (nowSec >= asr && nowSec < maghrib) {
        setCurrentPrayer("Asr");
      } else if (nowSec >= maghrib && nowSec < isha) {
        setCurrentPrayer("Maghrib");
      } else {
        // Isha until next day's Fajr
        setCurrentPrayer("Isha");
      }
    };

    checkPrayer();
    const interval = setInterval(checkPrayer, 1000);
    return () => clearInterval(interval);
  }, [data]);

  // console.log(currentPrayer);

  // above is for change the background to dark blue when preyer time thrashhold finishes or changes🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝
  // above is for change the background to dark blue when preyer time thrashhold finishes or changes🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝

  //below useeffect will refresh page everyday at 12:05AM

  // Convert "HH:MM" → seconds
  // PART 2 — FIXED BLACKOUT SECTION
  // -------------------------------------------------------------

  // ⭐ SAFE timeToSeconds (fixes your NaN bug)
  function timeToSeconds(str) {
    if (!str) return 0;
    const parts = str.trim().split(":");
    if (parts.length < 2) return 0;

    const h = Number(parts[0]);
    const m = Number(parts[1]);

    return h * 3600 + m * 60;
  }

  const [blackout, setBlackout] = useState(false);
  const [remaining, setRemaining] = useState(0);

  // durations in minutes
  const durations = {
    fajrIqamah: 20,
    dhuhrIqamah: 15,
    asrIqamah: 15,
    maghribIqamah: 20,
    ishaIqamah: 20,
  };

  // ⭐ Restore blackout on refresh
  useEffect(() => {
    const active = localStorage.getItem("blackoutActive");
    const endTime = localStorage.getItem("blackoutEndTime");

    if (active === "true" && endTime) {
      const remainingMs = Number(endTime) - Date.now();

      if (remainingMs > 0) {
        setBlackout(true);
        setRemaining(Math.floor(remainingMs / 1000));
      } else {
        localStorage.removeItem("blackoutActive");
        localStorage.removeItem("blackoutEndTime");
      }
    }
  }, []);

  // ⭐ Countdown timer
  useEffect(() => {
    if (!blackout) return;

    const interval = setInterval(() => {
      setRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setBlackout(false);

          localStorage.removeItem("blackoutActive");
          localStorage.removeItem("blackoutEndTime");

          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [blackout]);

  // ⭐ Trigger blackout + save to storage
  function triggerBlackout(minutes) {
    const endTime = Date.now() + minutes * 60 * 1000;

    setBlackout(true);
    setRemaining(minutes * 60);

    localStorage.setItem("blackoutActive", "true");
    localStorage.setItem("blackoutEndTime", endTime.toString());
  }

  // ⭐ Schedule blackout at iqamah times
  useEffect(() => {
    if (!data) return;

    const now = new Date();
    const todaySeconds =
      now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();

    Object.entries(durations).forEach(([key, minutes]) => {
      const targetSeconds = timeToSeconds(data[key]);
      const delay = (targetSeconds - todaySeconds) * 1000;

      if (delay > 0) {
        setTimeout(() => {
          // ⭐ FIX: recalc time inside timeout
          const now2 = new Date();
          const weekday = now2.toLocaleDateString(undefined, {
            weekday: "long",
          });

          if (key === "dhuhrIqamah" && weekday === "Friday") {
            triggerBlackout(60);
          } else {
            triggerBlackout(minutes);
          }
        }, delay);
      }
    });
  }, [data]);

  // Format remaining time
  function formatTime2(sec) {
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = sec % 60;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(
      2,
      "0",
    )}:${String(s).padStart(2, "0")}`;
  }

  // -------------------------------------------------------------
  // REST OF YOUR CODE BELOW REMAINS EXACTLY THE SAME

  // above is for black screen for 10 minutes at prayer
  // below fetch breaking news from API
  // below fetch breaking news from API
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetchItems().then((all) => setItems(all.filter((i) => i.visible)));
  }, []);
  // console.log(items);
  // above fetch breaking news from API
  // above fetch breaking news from API

  const [isVisible1, setIsVisible1] = useState(true);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIsVisible1((prevIsVisible) => !prevIsVisible);
    }, 1000); // Toggle visibility every 500ms

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);

  if (isLoading) {
    return <div>Loading...</div>; // Render a loading state first
  }

  if (error) {
    return <div>Error Loading</div>; // Render a loading state first
  }
  return (
    <div style={wrapperStyle}>
      <div style={rotatedStyle}>
        <div
          style={{
            width: "97%",
            // height: "100vh",

            // filter: "drop-shadow(0 0 2px #6F47D3)",

            // background: "#316997ff",
            // background: "#3d7effff",
            background: "#ffffffff",

            color: "#0070bb",
            // border: "2px solid red",
            float: "left",
          }}
        >
          <div
            className="lontainer wrapper "
            style={{
              marginTop: "-35px",
              // marginBottom: "-10px",
            }}
          >
            <img
              src={MICLogo}
              className="icon-image"
              alt="Left Icon"
              // class=""
              style={{
                height: 70,
                width: 70,
                // marginTop: "-35px",
                // marginRight: "50px",
                //  gap: '100px'
              }}
            />

            <h3
              // className="word"
              // id="myText"
              style={{
                textAlign: "center",
                // marginTop: "1px",
                // marginBottom: "30px",
                fontSize: "40px",
                // fontFamily: "DM Sans, sans-serif",
                fontFamily: "Quicksand, sans-serif",

                fontStyle: "normal",
                // display: 'inline',
                letterSpacing: 3,
                // letterSpacing: "6px",
                color: "#0070bb",
                // textShadow: "2px 2px #1c7a1f",
              }}
            >
              MIDDLETOWN ISLAMIC CENTER (NEW YORK)
            </h3>
            <img
              src={MICLogo}
              className="icon-image"
              alt="Right Icon"
              style={{
                height: 70,
                width: 70,
                // marginTop: "-35px",
                // marginLeft: "50px",
                //  gap: '100px'
              }}
            />
          </div>

          {/* <br />
          <br /> */}

          <div
            className="Table-Title-div"
            style={{
              marginTop: "-29px",
            }}
          >
            <table
              style={{
                width: "100%",

                fontSize: "30px",
                border: "none !important",
                // filter: "drop-shadow(0 0 2px #6F47D3)",
              }}
            >
              <tr style={{}}>
                <td
                  style={{
                    width: "20%",

                    // background: "#80CBC4",
                  }}
                >
                  <b> </b>
                </td>

                <td
                  style={{
                    width: "40%",
                    textAlign: "center",
                    fontFamily: "Quicksand, sans-serif",
                    fontWeight: "bold",
                    fontSize: "40px",

                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  ATHAN
                </td>

                <td
                  style={{
                    width: "40%",
                    fontFamily: "Quicksand, sans-serif",
                    textAlign: "center",
                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                    fontWeight: "bold",
                    fontSize: "40px",
                  }}
                >
                  IQAMAH
                </td>
              </tr>
            </table>
          </div>
          <div
            className={`box ${
              currentPrayer === "Fajr" ? "active bestseller" : ""
            }`}
          >
            <table
              style={{
                width: "100%",
                marginTop: "-2px",
                border: "none !important",
                // filter: "drop-shadow(0 0 2px #6F47D3)",
              }}
            >
              <tr style={{}}>
                <td
                  style={{
                    width: "20%",
                    fontFamily: "Quicksand, sans-serif",
                    fontWeight: "bold",
                    textAlign: "right",
                    fontSize: "45px",
                    verticalAlign: "bottom",

                    // background: "#80CBC4",
                  }}
                >
                  <b></b> FAJR
                </td>

                <td
                  style={{
                    width: "40%",
                    textAlign: "right",
                    fontWeight: "bold",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    borderRight: "1px solid #dddddd",
                    borderLeft: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* 56:56 PM <br /> */}
                  {/* {formatTimeAMPM(bb.Fajr)}
                   */}
                  {data && format12h(data?.fajr)}
                </td>

                <td
                  style={{
                    width: "40%",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    textAlign: "center",
                    fontWeight: "bold",

                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* {formatTimeAMPM(bb.Fajr_Iqamah)} */}
                  {data && format12h(data?.fajrIqamah)}
                </td>
              </tr>
            </table>
          </div>
          <div
            className={`box ${
              currentPrayer === "Dhuhr" ? "active bestseller" : ""
            }`}
          >
            <table
              style={{
                width: "100%",
                marginTop: "-2px",
                border: "none !important",
                // filter: "drop-shadow(0 0 2px #6F47D3)",
              }}
            >
              <tr style={{}}>
                <td
                  style={{
                    width: "20%",
                    fontFamily: "Quicksand, sans-serif",
                    fontWeight: "bold",
                    textAlign: "right",
                    verticalAlign: "bottom",
                    fontSize: "40px",
                    // background: "#80CBC4",
                  }}
                >
                  <b></b>DHUHR
                </td>

                <td
                  style={{
                    width: "42%",
                    textAlign: "right",
                    fontWeight: "bold",
                    fontSize: "87px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    borderRight: "1px solid #dddddd",
                    borderLeft: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* {formatTimeAMPM(bb.Dhuhr)} */}
                  {data && format12h(data?.dhuhr)}
                </td>

                <td
                  style={{
                    width: "40%",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    textAlign: "center",

                    fontWeight: "bold",
                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* {formatTimeAMPM(bb.Dhuhr_Iqamah)} */}
                  {data && format12h(data?.dhuhrIqamah)}
                </td>
              </tr>
            </table>
          </div>
          <div
            className={`box ${
              currentPrayer === "Asr" ? "active bestseller" : ""
            }`}
          >
            <table
              style={{
                width: "100%",
                marginTop: "-2px",
                border: "none !important",
                // filter: "drop-shadow(0 0 2px #6F47D3)",
              }}
            >
              <tr style={{}}>
                <td
                  style={{
                    width: "20%",
                    fontFamily: "Quicksand, sans-serif",
                    verticalAlign: "bottom",

                    fontWeight: "bold",
                    textAlign: "right",
                    fontSize: "45px",
                  }}
                >
                  <b></b>ASR
                </td>

                <td
                  style={{
                    width: "40%",
                    textAlign: "right",
                    fontWeight: "bold",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    borderRight: "1px solid #dddddd",
                    borderLeft: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* {formatTimeAMPM(bb.Asr)} */}
                  {data && format12h(data?.asr)}
                </td>

                <td
                  style={{
                    width: "40%",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    textAlign: "center",

                    fontWeight: "bold",
                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* {formatTimeAMPM(bb.Asr_Iqamah)} */}
                  {data && format12h(data?.asrIqamah)}
                </td>
              </tr>
            </table>
          </div>
          <div
            className={`box ${
              currentPrayer === "Maghrib" ? "active bestseller" : ""
            }`}
          >
            <table
              style={{
                width: "100%",
                marginTop: "-2px",
                border: "none !important",
                // filter: "drop-shadow(0 0 2px #6F47D3)",
              }}
            >
              <tr style={{}}>
                <td
                  style={{
                    width: "20%",
                    fontFamily: "Quicksand, sans-serif",
                    verticalAlign: "bottom",
                    letterSpacing: -3,
                    fontWeight: "bold",
                    textAlign: "right",
                    fontSize: "45px",
                  }}
                >
                  <b></b>MAGRIB
                </td>

                <td
                  style={{
                    width: "40%",
                    textAlign: "right",
                    fontWeight: "bold",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    borderRight: "1px solid #dddddd",
                    borderLeft: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* {formatTimeAMPM(bb.Maghrib)} */}
                  {data && format12h(data?.maghrib)}
                </td>

                <td
                  style={{
                    width: "40%",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    textAlign: "center",

                    fontWeight: "bold",
                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* {formatTimeAMPM(bb.Maghrib_Iqamah)} */}
                  {data && format12h(data?.maghribIqamah)}
                </td>
              </tr>
            </table>
          </div>
          <div
            className={`box ${
              currentPrayer === "Isha" ? "active bestseller" : ""
            }`}
          >
            <table
              style={{
                width: "100%",
                marginTop: "-2px",
                border: "none !important",
                // filter: "drop-shadow(0 0 2px #6F47D3)",
              }}
            >
              <tr style={{}}>
                <td
                  style={{
                    width: "20%",
                    fontFamily: "Quicksand, sans-serif",
                    verticalAlign: "bottom",

                    fontWeight: "bold",
                    textAlign: "right",
                    fontSize: "45px",
                  }}
                >
                  <b></b>ISHA
                </td>

                <td
                  style={{
                    width: "40%",
                    textAlign: "right",
                    fontWeight: "bold",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    borderRight: "1px solid #dddddd",
                    borderLeft: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* {formatTimeAMPM(bb.Isha)} */}
                  {data && format12h(data?.isha)}
                </td>

                <td
                  style={{
                    width: "40%",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    textAlign: "center",

                    fontWeight: "bold",
                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* {formatTimeAMPM(bb.Isha_Iqamah)} */}
                  {data && format12h(data?.ishaIqamah)}
                </td>
              </tr>
            </table>
          </div>
          <div className="box">
            <table
              style={{
                width: "100%",
                marginTop: "-2px",
                // border: "none !important",
                // filter: "drop-shadow(0 0 2px #6F47D3)",
              }}
            >
              <tr style={{}}>
                <td
                  style={{
                    width: "20%",
                    fontFamily: "Quicksand, sans-serif",
                    verticalAlign: "bottom",
                    letterSpacing: -3,

                    fontWeight: "bold",
                    textAlign: "right",
                    fontSize: "45px",
                  }}
                >
                  <b></b>JUMUAH
                </td>

                <td
                  style={{
                    width: "40%",
                    textAlign: "right",
                    fontWeight: "bold",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    borderRight: "1px solid #dddddd",
                    borderLeft: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* 1:00 PM */}
                  {data && format12h(data?.jumuah)}
                </td>

                <td
                  style={{
                    width: "40%",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    textAlign: "center",

                    fontWeight: "bold",
                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {data && format12h(data?.jumuahIqamah)}
                </td>
              </tr>
            </table>
          </div>
          <p
            style={{
              textAlign: "center",
              marginTop: "10px",
              fontSize: "68px",
              marginBottom: "-13px",
              // width: "40%",
              // fontSize: "90px",
              letterSpacing: "-2px",
              // fontFamily: "Quicksand, sans-serif",
              // textAlign: "center",

              // fontWeight: "bold",
            }}
          >
            {/* <strong style={{}}>TODAY:</strong> <br /> */}
            {today} <br />
            {/* <strong>NOW:</strong> <br /> */}
            <span
              style={{
                fontFamily: "Space Mono, monospace",
                fontSize: "130px",
                letterSpacing: "-8px",
              }}
            >
              {now}{" "}
            </span>
          </p>

          <p
            style={{
              marginTop: "8px",
              color: "black",
              fontFamily: "Quicksand, sans-serif",
              fontSize: "50px",
              textAlign: "center",
            }}
          >
            {/* <b>{hijriDate}</b> */}
            {writeIslamicDate()}
          </p>

          {breakingNews && breakingNews.length > 0 ? (
            <h1
              style={{
                fontSize: "35px",
                textAlign: "center",
                marginTop: "-35px",
                color: "black",
              }}
            >
              Breaking News
            </h1>
          ) : (
            <></>
          )}

          <p
            style={{
              // color: "red",

              // whiteSpace: "pre-line",
              // color: "black",
              textAlign: "center",
              alignItems: "center",
            }}
          >
            {items && items.length > 0 ? (
              items.map((breakingNew, i) => (
                <>
                  <div
                    style={{
                      color: "red",
                      fontSize: "28px",
                      marginTop: "-15px",

                      whiteSpace: "pre-line",
                      color: "#ff0000ff",
                      textAlign: "center",

                      opacity: isVisible1 ? 1 : 0, // Control visibility with opacity
                      transition: "opacity 0.2s ease-in-out", // Smooth transition for blinking
                      alignItems: "center",
                    }}
                  >
                    {breakingNew.text}
                    {/* <br />
                  <br />
                  <br />
                  <br /> */}
                  </div>
                </>
              ))
            ) : (
              // : breakingNews?.length === 2 ? (
              //   breakingNews.map((breakingNew, i) => (
              //     <>
              //       <div>{breakingNew.text}</div>
              //     </>
              //   ))
              // )
              // .join(" || ")
              <div
                style={{
                  fontSize: "25px",
                  backgroundColor: " #ffffffff",
                  color: "black",
                  // overflow: "hidden",
                  // whiteSpace: "nowrap",
                  boxSizing: "border-box",
                  // position: "relative",
                }}
              ></div>
            )}
          </p>
          <br />

          <br />
          <div
            style={{
              background: "#000",
              marginTop: "15px",
              height: "45px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <b>
              <marquee
                direction="left"
                // scrollamount="5"
                // vspace="20"
                style={{
                  fontSize: "45px",
                  color: "black",
                  backgroundColor: " #000",
                  color: "white",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  boxSizing: "border-box",
                  position: "relative",
                }}
              >
                {notes && notes.length > 0
                  ? notes.map((note) => `${note.text}`).join(" | ")
                  : "No Notes Available"}{" "}
                &nbsp;Have a Blessed Day! Ramadhan begins on February 18th
                2026(1447), Wednesday.
                <span style={{ background: "red" }}>
                  (Subject to moon sighting)
                </span>{" "}
                | If you wish to host Iftar please contact brother AKHTAR ALI
                (845.520.1311) |&nbsp;
                <span style={{ background: "black", color: "white" }}>
                  {/* Application Developer: MEHDI HASAN | 845.514.8834 | Message To
              Suggest. */}
                </span>
              </marquee>
            </b>
          </div>
        </div>
      </div>
    </div>
  );
  {
    blackout && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "black",
          zIndex: 999999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          fontSize: "60px",
          fontWeight: "bold",
        }}
      >
        {formatTime2(remaining)}
      </div>
    );
  }
}
